import React, { useState } from 'react';
import CompanyDetailsStep from './CompanyDetailsStep';
import ProductsStep from './ProductsStep';
import CompetitorsStep from './CompetitorsStep';

const OnboardingWizard = () => {
    const [step, setStep] = useState(1);
    const [companyId, setCompanyId] = useState<string | null>(null);

    const nextStep = () => setStep(step + 1);
    const prevStep = () => setStep(step - 1);

    switch (step) {
        case 1:
            return <CompanyDetailsStep nextStep={nextStep} setCompanyId={setCompanyId} />;
        case 2:
            return <ProductsStep nextStep={nextStep} prevStep={prevStep} companyId={companyId} />;
        case 3:
            return <CompetitorsStep prevStep={prevStep} companyId={companyId} />;
        default:
            return <div>Onboarding Complete!</div>;
    }
};

export default OnboardingWizard;
